<template>
<div class="kiwi-container">
  <el-row>
    <el-col class="title" :span="12">
      <p>Why Kiwigame</p>
    </el-col>
  </el-row>
  <el-row>
    <el-col class="creat-banner inner-banner" :span="24">
      <img :src="imageRoot + '/home/create_banner_2.png'" alt="">
    </el-col>
    <el-col>
      <el-row class="reason" :gutter="0">
        <el-col :span="8">
          <div
            class="enthusiast reason-img"
            :class="{active: isactive.enthusiast}"
            @mouseenter="expendDesc"
            @mouseleave="collapseDesc"
          >
            <img :src="imageRoot + '/home/Game Enthusiast.png'">
            <transition name="fade">
              <p v-show="isactive.enthusiast">Work should be fun! Join us now to release your creativity and develop your skills!</p>
            </transition>
          </div>
        </el-col>
        <el-col :span="8">
          <div
            class="hours reason-img"
            :class="{active: isactive.hours}"
            @mouseenter="expendDesc"
            @mouseleave="collapseDesc"
          >
            <img :src="imageRoot + '/home/Opportune Hours.png'" alt="" srcset="">
            <transition name="fade">
              <p v-show="isactive.hours">Avoid the early starts and rush hour, with 10 am starts (Off-Peak)</p>
            </transition>
          </div>
        </el-col>
        <el-col class="reason-list" :span="8">
          <div
            class="gamejam reason-img"
            :class="{active: isactive.gamejam}"
            @mouseenter="expendDesc"
            @mouseleave="collapseDesc"
          >
            <img :src="imageRoot + '/home/Gamejam.png'" alt="" srcset="">
            <transition name="fade">
              <p v-show="isactive.gamejam">A game development held twice a year! Team up to win up to a ￥40,000 bonus!</p>
            </transition>
          </div>
        </el-col>
      </el-row>
    </el-col>
    <el-col class="welfare-banner inner-banner" :span="24">
      <img :src="imageRoot + '/home/wellare_banner.png'" alt="">
    </el-col>
    <el-col class="welfare-banner-list" :span="24">
      <el-row :gutter="0" class="welfare-reason">
        <el-col :span="5">
          <div
            class="salaries welfare-reason-img"
            @mouseenter="expendDesc"
            @mouseleave="collapseDesc"
            :class="{active: isactive.salaries}"
          >
            <img :src="imageRoot + '/home/Generous Salaries.png'" alt="" srcset="">
            <transition name="fade">
              <p v-show="isactive.salaries">
                <span>Quarterly salary-increment opportunity</span><br>
                <span>Monthly, quarterly, & annual bonuses</span><br>
                <span>13th salary</span><br>
              </p>
            </transition>
          </div>
        </el-col>
        <el-col :span="5">
          <div
            class="overseas welfare-reason-img"
            @mouseenter="expendDesc"
            @mouseleave="collapseDesc"
            :class="{active: isactive.overseas}"
          >
            <img :src="imageRoot + '/home/Travel Overseas.png'" alt="" srcset="">
            <transition name="fade">
              <p v-show="isactive.overseas"><span>Twice a year!</span></p>
            </transition>
          </div>
        </el-col>
        <el-col :span="5">
          <div
            class="employee welfare-reason-img"
            @mouseenter="expendDesc"
            @mouseleave="collapseDesc"
            :class="{active: isactive.employee}"
          >
            <img :src="imageRoot + '/home/Employee Awards.png'" alt="" srcset="">
            <transition name="fade">
              <p v-show="isactive.employee">
              <span>Seasonal contribution awards</span><br>
              <span>Outstanding employee awards</span><br>
              <span>Talent-scout awards</span><br>
              </p>
            </transition>
          </div>
        </el-col>
        <el-col :span="5">
          <div
            class="generous welfare-reason-img"
            @mouseenter="expendDesc"
            @mouseleave="collapseDesc"
            :class="{active: isactive.generous}"
          >
            <img :src="imageRoot + '/home/Generous Vacation Days.png'" alt="" srcset="">
            <transition name="fade">
              <p v-show="isactive.generous">
                <span>Annual vacation days</span><br>
                <span>Public holidays</span><br>
              </p>
            </transition>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="health welfare-reason-img"
            @mouseenter="expendDesc"
            @mouseleave="collapseDesc"
            :class="{active: isactive.health}"
          >
            <img :src="imageRoot + '/home/Health Care Benefits.png'" alt="" srcset="">
            <transition name="fade">
              <p v-show="isactive.health">
               <span>Five one insurance fund</span><br>
               <span>Annual health check-up</span><br>
               <span>Paid medical leave</span><br>
              </p>
            </transition>
          </div>
        </el-col>
      </el-row>
    </el-col>
    <el-col class="growth-banner inner-banner" :span="24">
      <img :src="imageRoot + '/home/growthbanner_2.png'" alt="">
    </el-col>
    <el-col class="growth-banner-list" :span="23">
      <el-row :gutter="0" class="life-reason"  type='flex' justify="space-between" >
        <el-col :span="5">
          <div
            class="lifelong life-reason-img"
            @mouseenter="expendDesc"
            @mouseleave="collapseDesc"
            :class="{active: isactive.lifelong}"
          >
            <img :src="imageRoot + '/home/Lifelong  learning program_2.png'" alt="" srcset="">
            <transition name="fade">
              <p v-show="isactive.lifelong">
               <span>Fully-paid training & learning courses</span>
              </p>
            </transition>
          </div>
        </el-col>
        <el-col :span="5">
          <div
            class="mentoring life-reason-img"
            @mouseenter="expendDesc"
            @mouseleave="collapseDesc"
            :class="{active: isactive.mentoring}"
          >
            <img :src="imageRoot + '/home/Mentoring system_2.png'" alt="" srcset="">
            <transition name="fade">
              <p v-show="isactive.mentoring">
                <span>One-to-one training</span><br>
                <span>Senior leader guidance</span><br>
              </p>
            </transition>
          </div>
        </el-col>
        <el-col :span="5">
          <div
            class="TEDKiwigame life-reason-img"
            @mouseenter="expendDesc"
            @mouseleave="collapseDesc"
            :class="{active: isactive.TEDKiwigame}"
          >
            <img :src="imageRoot + '/home/TEDKiwigame.png'" alt="" srcset="">
            <transition name="fade">
              <p v-show="isactive.TEDKiwigame">
                <span>Ideas worth spreading!</span>
              </p>
            </transition>
          </div>
        </el-col>
        <el-col :span="5">
          <div
            class="library life-reason-img"
            @mouseenter="expendDesc"
            @mouseleave="collapseDesc"
            :class="{active: isactive.library}"
          >
            <img :src="imageRoot + '/home/Mobile Library.png'" alt="" srcset="">
            <transition name="fade">
              <p v-show="isactive.library">
                <span>Excellent book resources updated monthy!</span>
              </p>
            </transition>
          </div>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</div>
</template>

<script>
export default {

  data: function () {
    return {
      isactive: {
        'enthusiast': true,
        'hours': false,
        'gamejam': false,
        'salaries': true,
        'overseas': false,
        'employee': false,
        'generous': false,
        'health': false,
        'lifelong': false,
        'mentoring': false,
        'TEDKiwigame': false,
        'library': false
      },
      imageRoot: process.env.VUE_APP_IMAGE_PATH
    }
  },
  methods: {
    expendDesc (res) {
      let className = res.target.className.split(' ')[0]
      for (const [key, value] of Object.entries(this.isactive)) {
        if (value) {
          this.isactive[key] = false
        }
      }
      this.isactive[className] = true
    },
    collapseDesc (res) {
      let className = res.target.className.split(' ')[0]
      this.isactive[className] = false
    }
  }

}
</script>

<style lang='scss' scoped>
.kiwi-container{
  .title{
    @include normalTitle('#{$imageRoot}/home/title_dot.png',45px, 45px, -27px, 114px, 2, 116.8px);
  }
  .inner-banner{
    img{
      width: 840px;
      margin-top: 54px;
      margin-left: -28px;
    }
  }
  .welfare-banner{
    img{
      margin-top: 22px;
    }
  }
}
.reason-list{
  height: 260px;
  margin-bottom: 0;
}
.reason{
  margin-top: 84px;
  >.el-col{
    height: 290px;
  }
  .reason-img{
    width: 260px;
    border: 1px solid #c1f9dd;
    box-shadow: 8px 8px 8px rgba(206,236,221,0.26);
    border-radius:10px;
    margin-left: -28px;
    text-align: center;
    img{
      width:230px
    }
    &.active{
      background-color: #f3fff9;
      p{
        text-align: left;
        padding: 0px 16px 15px 20px;
        font-family: $fontFmaily;
        font-size: 15px;
        color: #636363;
        margin: 0;
        line-height: 27px;
        display: block;
        height:116px;
        position: relative;
        span::before{
          content: '\2022';
          position: absolute;
          left: 8px;
        }
      }
    }
    p{
      display: none;
    }

  }
}
</style>

<style lang="scss" scoped>
  .welfare-banner-list{
    margin-top: 84px;
  }
  .welfare-reason{
    position: absolute;
    max-width: 840px;
    margin-left: -28px;
  }
  .welfare-reason-img{
    width:158px;
    border: 1px solid #c1f9dd;
    box-shadow: 8px 8px 8px rgba(206,236,221,0.26);
    border-radius:10px;
    margin-left:3px;
    img{
      width: 157px;
    }
    &.active{
      background-color: #f3fff9;
      p{
        padding: 0px 16px 15px 20px;
        font-family: $fontFmaily;
        font-size: 15px;
        color: #636363;
        margin: 0;
        line-height: 27px;
        display: block !important;
        height:fit-content;
        min-height: 50px;
        position: relative;
        span::before{
          content: '\2022';
          position: absolute;
          left: 8px;
        }
      }
    }
    p{
      display: none;
    }
  }
  .growth-banner{
    margin-top: 270px;
  }
  .growth-banner-list{
    margin-top: 84px;
    height: 250px;
    margin-left:-28px;
  }
  .life-reason-img{
    width:189px;
    border: 1px solid #c1f9dd;
    box-shadow: 8px 8px 8px rgba(206,236,221,0.26);
    border-radius:10px;
    text-align: center;
    img{
      width: 180px;
    }
    &.active{
      background-color: #f3fff9;
      p{
        text-align: left;
        padding: 0px 16px 15px 26px;
        font-family: $fontFmaily;
        font-size: 15px;
        color: #636363;
        margin: 0;
        line-height: 27px;
        display: block !important;
        height:fit-content;
        min-height: 50px;
        position: relative;
        span::before{
          content: '\2022';
          position: absolute;
          left: 8px;
        }
      }
    }
    p{
      display: none;
    }
  }
</style>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 1.8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
